import { Api } from 'utils';

class SignatureService {
  static save = async (params = {}) => Api.createResponse('app/signatures/save', params);
  static saveResponse = async (params = {}) =>
    Api.createResponse('app/signatures/save-response', params);
  static get = async (params = {}) => Api.createResponse('app/signatures/', params);
  static rating = async (params = {}) => Api.createResponse('app/signatures/rating', params);
  static changeStatus = async (params = {}) =>
    Api.createResponse('app/signatures/change-status', params);

  // ── Feature "invitar firmantes" ─────────────────────────────────────────
  static searchUser = async (params = {}) =>
    Api.createResponse('app/signatures/search-user', params);
  static inviteSigners = async (params = {}) =>
    Api.createResponse('app/signatures/invite-signers', params);
  static getPendingRequests = async (params = {}) =>
    Api.createResponse('app/signatures/pending-requests', params);
  static reportSigned = async (params = {}) =>
    Api.createResponse('app/signatures/report-signed', params);

  static admin = {
    get: async (params?: any) => Api.createResponse('admin/signatures/', params),
    assign: async (params?: any) => Api.createResponse('admin/signatures/assign', params),
  };
}

export default SignatureService;
